import { http } from "./http";

/**
 * Banco de dados DOS PROJETOS GERADOS (nunca o banco do Builder).
 * Somente inspeção: não existe execução de SQL livre para usuários comuns.
 */

export interface DbSchema {
  name: string;
  tables: number;
}

export interface DbTable {
  schema: string;
  name: string;
  kind: string;
  approximate_rows: number;
  size: string | null;
  comment: string | null;
}

export interface DbColumn {
  schema: string;
  table: string;
  name: string;
  position: number;
  type: string;
  length: number | null;
  nullable: boolean;
  default: string | null;
}

export interface DbIndex {
  schema: string;
  table: string;
  name: string;
  definition: string;
  unique: boolean;
}

export interface DbForeignKey {
  schema: string;
  table: string;
  name: string;
  definition: string;
  references_schema: string;
  references_table: string;
}

export interface DbMigration {
  name: string;
  path: string;
  applied: boolean;
  batch: number | null;
}

export interface ProjectDatabase {
  enabled: boolean;
  sql_console: boolean;
  status: "empty" | "pending" | "ready" | "failed";
  generated_at: string | null;
  error: string | null;
  schemas: DbSchema[];
  tables: DbTable[];
  columns: DbColumn[];
  indexes: DbIndex[];
  foreign_keys: DbForeignKey[];
  migrations: DbMigration[];
  rows_per_page: number;
}

export interface DbRowsResult {
  status: "pending" | "ready" | "failed" | "expired";
  schema?: string;
  table?: string;
  page?: number;
  per_page?: number;
  total?: number;
  rows?: Record<string, unknown>[];
  error?: string;
}

export const databaseService = {
  get: (project: string) => http.get<ProjectDatabase>(`/projects/${project}/database`),
  refresh: (project: string) =>
    http.post<{ status: string }>(`/projects/${project}/database/refresh`, {}),
  requestRows: (project: string, schema: string, table: string, page: number) =>
    http.post<{ token: string; status: string }>(`/projects/${project}/database/rows`, {
      schema,
      table,
      page,
    }),
  rowsResult: (project: string, token: string) =>
    http.get<DbRowsResult>(`/projects/${project}/database/rows/${token}`),
};
